import * as React from 'react'

import { Box, tokens } from '@factorialco/deprecated-design-system'

import PeriodSelector from './_PeriodSelector'
import SummaryCard from './_SummaryCard'

const Summary = () => {
  return (
    <Box
      gap="s24"
      alignItems="flexEnd"
      position="sticky"
      style={{ top: tokens.dimensions.s24 }}
      paddingTop="s4"
    >
      <PeriodSelector />
      <SummaryCard />
    </Box>
  )
}

export default Summary
